import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';

import {
  getHeaderLinkMediumColor,
  getHeaderLinkColor
} from 'styles/helpers/getThemeStyles';
import { HEADER } from 'styles/constants/appearanceSectionNames';

// TODO: Reintroduce dark when working on styling AppBar
const DesignAndCustomizationLinkLabel = styled(Typography, {
  shouldForwardProp: muiPropForwarding('highlighted')
})(({ theme, highlighted }) => ({
  textAlign: 'left',
  fontSize: '14px',
  color: getHeaderLinkColor(theme),
  [theme.breakpoints.up('md')]: {
    lineHeight: 1.2,
    fontSize: '16px',
    color: `${
      highlighted ? getHeaderLinkColor(theme) : getHeaderLinkMediumColor(theme)
    }`
  }
}));

function AppBarLinkLabel({ children, ...rest }) {
  const { highlighted } = rest;
  const styles = { variant: HEADER, highlighted };

  return (
    <DesignAndCustomizationLinkLabel {...styles}>
      {children}
    </DesignAndCustomizationLinkLabel>
  );
}

AppBarLinkLabel.defaultProps = {
  fullWidth: false
};

AppBarLinkLabel.propTypes = {
  highlighted: PropTypes.bool,
  children: PropTypes.node
};

export default AppBarLinkLabel;
